const getFilterType = filterTerm =>
  filterTerm.__typename.replace(
    /VerificationRule(\w)(\w+)FilterTerm/,
    ($0, $1, $2) => $1.toLowerCase() + $2
  );

export default getFilterType;



// WEBPACK FOOTER //
// ./src/utils/getFilterType.js